import api from "../../index";

let employeeListPromise = null;

const invalidateEmployeeListCache = () => {
    employeeListPromise = null;
};

export const AddNewTeamMemberApi = (data) => {
    invalidateEmployeeListCache();
    return api.post('add-employee', data);
}; // Employee

export const GetTeamMemberListApi = () => {
    if (!employeeListPromise) {
        employeeListPromise = api.post('employee-list').catch((error) => {
            employeeListPromise = null;
            throw error;
        });
    }
    return employeeListPromise;
};

export const GetEmployeeTaskListApi = () => api.post('task-permission-list');
export const ChangeEmployeeStatusApi = (data) => {
    invalidateEmployeeListCache();
    return api.post('change-user-status', data);
};
export const AssignPermissionApi = (data) => api.post('add-permissions-to-employee', data);
export const UpdateAssignedPermissionApi = (data) => api.post('update-permissions-to-employee', data);
export const GetEmployeePermissionApi = (data) => api.post('get-tasks-by-employee', data);
export const GetUserActivityListApi = (data) => api.post('user-activities', data);
export const DeleteTeamMemberApi = (data) => {
    invalidateEmployeeListCache();
    return api.post('delete-team-member', data);
};